<!DOCTYPE html>
<html lang="en" xml:lang="en">
  <head>
    <title>ACCOUNT DELETED SUCESSFULLY</title>
  </head>
  <body>
    <div>
      <div class="error-container">
        <h1>ACCOUNT DELETED SUCESSFULLY</h1>
        <h2>Thanks for being a valuable customer!</h2>
        <div>
          <a
            href="login"
            class="btn btn btn-lg"
            style="background-color: #FFD958;color: #000;"
            >Take Me Home</a
          >
          <a href="login" class="btn btn btn-lg text-white">Contact Support</a>
        </div>
      </div>
    </div>
  </body>
</html>
